@if (dataResource.hasValue()) {
  <div
    #visNetwork
    class="visjs-container"
    [style.background-image]="backgroundImage() ? 'url(' + backgroundImage() + ')' : null"
  ></div>
} @else if (dataResource.error(); as error) {
  <div class="alert alert-danger">{{ error }}</div>
} @else {
<!-- app-loading takes all the screen space and breaks hovering -->
<!--
  <div class="d-flex justify-content-center p-3">
    <app-loading/>
  </div>
-->
}
